import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as TrackingToolToEditorPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/editor";
import { Route as TrackingToolToGeneralPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/_layout/general";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api/_layout/$id/"
)({
    component: TrackingToolToDetailPage,
    staticData: {
        permissions: [PermissionEnum.ToolTrackingOutgoingEditGeneral, PermissionEnum.ToolTrackingOutgoingEditEditor],
        showInSideMenu: false,
        label: "pages.tool.tracking.to.general.title",
        redirects: [TrackingToolToGeneralPage, TrackingToolToEditorPage],
        defaultRedirect: TrackingToolToGeneralPage,
    },
});

function TrackingToolToDetailPage() {
    return <RedirectPage />;
}
